var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCitas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,117.2V60.9h-65.6v56.3H60.9v65.5h56.3v56.3h65.6v-56.3h56.3v-65.5H182.8z M150,5C70.1,5,5,70,5,150 c0,23.6,5.8,45.9,15.9,65.6L5,295l79.4-15.9c19.7,10.1,42,15.9,65.6,15.9c80,0,145-65.1,145-145C295,70,230,5,150,5z M150,268.6 c-65.4,0-118.6-53.2-118.6-118.6C31.4,84.6,84.6,31.4,150,31.4c65.4,0,118.6,53.2,118.6,118.6C268.6,215.4,215.4,268.6,150,268.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitas);
export default __webpack_public_path__ + "static/media/citas.0931b7ee6e03a896d43aa6e880671d9f.svg";
export { ForwardRef as ReactComponent };